<script setup lang="ts">
import RefineInterestsForm from '~/components/forms/contact/RefineInterestsForm.vue'
import HSForm from '~/components/forms/HSForm.vue'

withDefaults(
  defineProps<{
    withCloseButton?: boolean
  }>(),
  {
    withCloseButton: true,
  },
)

const config = useRuntimeConfig()
const formId = config.public.hubspotGovernmentalEnquiryFormId as string
</script>

<template>
  <HSForm
    class="h-full"
    :form-id="formId"
    :with-close-button="withCloseButton"
    @close="$emit('close')"
  >
    <template #header>
      <slot name="header" />
      <h5 class="text-lg font-semibold mb-3">A governmental enquiry</h5>
      <p class="ml-auto w-fit text-xxs">
        Fields marked <span class="text-error">*</span> are required
      </p>
    </template>
    <template #success="{ closeForm }">
      <RefineInterestsForm
        :with-close-button="withCloseButton"
        @close="closeForm"
      />
    </template>
  </HSForm>
</template>
